import { useSelector } from "react-redux";
import { LayoutAdminCafe, LayoutUserCafe } from "../../../layout/layout_cafe";
import StatusOrderCard from "../../../pages/users/status_order/components/statusOrderPage";
import { State } from "../../../reducer";

export function StatusOrderCafe() {
  const user = useSelector((state: State) => state.user);
  return (
    <>
      {user?.role === "admin" ? (
        <LayoutAdminCafe>
          <StatusOrderCard />
        </LayoutAdminCafe>
      ) : (
        <LayoutUserCafe>
          <StatusOrderCard />
        </LayoutUserCafe>
      )}
    </>
  );
}
